import React from 'react';
import { SegmentedControl, Tooltip } from '@mantine/core';
import { GANTT_TOOLBAR_BUTTON_RADIUS, GANTT_TOOLBAR_CONTROL_BORDER } from '../ganttToolbarStyles';
import type { GanttViewMode } from './targetsPeriodUtils';

export interface GanttViewModeToggleProps {
  value: GanttViewMode;
  onChange: (mode: GanttViewMode) => void;
  disabled?: boolean;
}

export function GanttViewModeToggle({ value, onChange, disabled }: GanttViewModeToggleProps) {
  return (
    <Tooltip
      label="Schedule shows the timeline. Look ahead replaces it with a near-term quantity grid."
      multiline
      w={260}
      withArrow
    >
      <SegmentedControl
        size="xs"
        color="brand"
        value={value}
        onChange={(next) => onChange(next as GanttViewMode)}
        data={[
          { value: 'schedule', label: 'Schedule' },
          { value: 'targets', label: 'Look ahead' },
        ]}
        disabled={disabled}
        aria-label="Schedule or Look ahead view"
        classNames={{
          root: 'gantt-scale-control-root',
          label: 'gantt-scale-control-label',
          indicator: 'gantt-scale-control-indicator',
        }}
        styles={{
          root: {
            height: 28,
            minHeight: 28,
            padding: 2,
            borderRadius: GANTT_TOOLBAR_BUTTON_RADIUS,
            border: GANTT_TOOLBAR_CONTROL_BORDER,
            background: 'var(--mantine-color-default-hover, #f1f3f5)',
          },
          label: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 13,
            fontWeight: 600,
            paddingLeft: 10,
            paddingRight: 10,
            minHeight: 22,
            height: 22,
            lineHeight: 1,
            textAlign: 'center',
          },
          control: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
        }}
      />
    </Tooltip>
  );
}
